/* =============================================
   Trust Badges — Slider + Animation Init
   Shares jQuery + Slick with products-cards.js.
   loadSlider() guards against double-loading via
   typeof-checks — Slick initialises once per page.
   ============================================= */
(function () {
  'use strict';

  var initialized = {};

  var PREV_ARROW =
    '<button type="button" class="tb-arr tb-arr--p" aria-label="Previous slide">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="15 18 9 12 15 6"/>' +
      '</svg>' +
    '</button>';

  var NEXT_ARROW =
    '<button type="button" class="tb-arr tb-arr--n" aria-label="Next slide">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<polyline points="9 18 15 12 9 6"/>' +
      '</svg>' +
    '</button>';

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSection(sectionEl) {
    var id = sectionEl.dataset.sectionId;
    if (initialized[id]) return;

    var grid     = sectionEl.querySelector('[data-tb-grid]');
    var controls = sectionEl.querySelector('[data-tb-controls]');
    if (!grid) return;

    var cfg        = (window.tbData && window.tbData[id]) || {};
    var isMobile   = window.matchMedia('(max-width: 749px)').matches;
    var isTablet   = window.matchMedia('(min-width: 750px) and (max-width: 1099px)').matches;
    var blockCount = parseInt(grid.dataset.blockCount, 10) || 0;
    var deskCols   = parseInt(cfg.colsDesktop, 10) || 3;
    var tabCols    = parseInt(cfg.colsTablet, 10) || 3;
    var mobCols    = parseInt(cfg.colsMobile, 10) || 1;

    var slidesToShow, shouldSlide;

    if (isMobile) {
      slidesToShow = mobCols;
      shouldSlide  = cfg.enableMobile === true && blockCount > mobCols;
    } else if (isTablet) {
      slidesToShow = tabCols;
      shouldSlide  = cfg.enableDesktop === true && blockCount > tabCols;
    } else {
      slidesToShow = deskCols;
      shouldSlide  = cfg.enableDesktop === true && blockCount > deskCols;
    }

    if (!shouldSlide) return;
    initialized[id] = true;

    loadSlider(function () {
      if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

      var $grid     = jQuery(grid);
      var $controls = controls ? jQuery(controls) : null;

      $grid.slick({
        slidesToShow:   slidesToShow,
        slidesToScroll: 1,
        autoplay:       cfg.autoplay === true && !prefersReducedMotion(),
        autoplaySpeed:  parseInt(cfg.autoplaySpeed, 10) || 4000,
        dots:           cfg.showDots !== false,
        arrows:         cfg.showArrows !== false,
        infinite:       cfg.infinite !== false,
        speed:          parseInt(cfg.transitionSpeed, 10) || 500,
        cssEase:        'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
        prevArrow:      PREV_ARROW,
        nextArrow:      NEXT_ARROW,
        customPaging: function (slider, i) {
          return '<button type="button" aria-label="Go to slide ' + (i + 1) + '"><span class="tb-dot"></span></button>';
        },
        appendArrows: $controls,
        appendDots:   $controls,
        responsive: [
          { breakpoint: 1100, settings: { slidesToShow: Math.min(tabCols, slidesToShow) } },
          { breakpoint: 750,  settings: { slidesToShow: mobCols, slidesToScroll: 1 } }
        ]
      });

      if ($controls) {
        $controls.addClass('tb__controls--visible').removeAttr('aria-hidden');
      }
    });
  }

  function initAnimations(sectionEl) {
    if (prefersReducedMotion()) return;
    var cards = sectionEl.querySelectorAll('[data-tb-animate]');
    if (!cards.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tb-anim--in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      cards.forEach(function (card) { io.observe(card); });
    } else {
      cards.forEach(function (card) { card.classList.add('tb-anim--in'); });
    }
  }

  /* Shared jQuery+Slick loader — same CDN handles as products-cards.js */
  function loadSlider(cb) {
    if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') { cb(); return; }

    function attachSlickCSS() {
      [
        'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css',
        'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css'
      ].forEach(function (href) {
        if (!document.querySelector('link[href="' + href + '"]')) {
          var l = document.createElement('link');
          l.rel = 'stylesheet'; l.href = href;
          document.head.appendChild(l);
        }
      });
    }

    function loadSlickJS() {
      if (typeof jQuery.fn.slick !== 'undefined') { cb(); return; }
      attachSlickCSS();
      appendScript('https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js', cb);
    }

    if (typeof jQuery === 'undefined') {
      appendScript('https://code.jquery.com/jquery-3.6.4.min.js', loadSlickJS);
    } else {
      loadSlickJS();
    }
  }

  function appendScript(src, onload) {
    var s = document.createElement('script');
    s.src = src; s.async = true; s.onload = onload;
    document.head.appendChild(s);
  }

  function observe() {
    var sections = document.querySelectorAll('.trust-badges-section');
    if (!sections.length) return;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            initSection(entry.target);
            initAnimations(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });
      sections.forEach(function (s) { io.observe(s); });
    } else {
      sections.forEach(function (s) { initSection(s); initAnimations(s); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  /* Shopify theme editor live-reload */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.trust-badges-section');
    if (!section) return;

    var id       = section.dataset.sectionId;
    var grid     = section.querySelector('[data-tb-grid]');
    var controls = section.querySelector('[data-tb-controls]');

    if (grid && typeof jQuery !== 'undefined' && jQuery(grid).hasClass('slick-initialized')) {
      jQuery(grid).slick('unslick');
    }
    if (controls) {
      controls.innerHTML = '';
      if (typeof jQuery !== 'undefined') {
        jQuery(controls).removeClass('tb__controls--visible').attr('aria-hidden', 'true');
      }
    }

    delete initialized[id];
    initSection(section);
    initAnimations(section);
  });

})();
